import * as numbers from "common/numbers";

export const resolveFlagsInputs = (flagsInput) => {
  if (
    flagsInput?.judgmentLimits == null ||
    flagsInput?.judgmentLimits?.ignoreOverrides
  ) {
    const judgmentFactor =
      (flagsInput?.judgments
        ?.map((_) => (100 + (parseFloat(_.value) || 0)) / 100)
        .reduce((a, b) => a * b, 1) || 0) *
        100 -
      100;
    return {
      ...flagsInput,
      judgments: flagsInput?.judgments || [],
      judgmentFactor,
      judgmentFactorWarning: false,
    };
  }

  const resolveJudgmentValue = (value) => {
    if (isNaN(parseFloat(value))) {
      return "";
    }

    return numbers.clamp(
      value,
      -flagsInput?.judgmentLimits?.maxDiscount,
      flagsInput?.judgmentLimits?.maxPenalty
    );
  };

  const resolvedJudgments = [
    ...flagsInput.judgments?.map((judgment) => ({
      ...judgment,
      value: resolveJudgmentValue(judgment.value),
    })),
    {
      value: "",
    },
  ];

  const resolvedJudgmentFactor =
    (resolvedJudgments
      ?.map((_) => (100 + (parseFloat(_.value) || 0)) / 100)
      .reduce((a, b) => a * b, 1) || 0) *
      100 -
    100;

  const judgmentFactorWarning =
    resolvedJudgmentFactor > flagsInput?.judgmentLimits?.overallMaxPenalty
      ? `Exceeds overall max penalty of ${flagsInput?.judgmentLimits?.overallMaxPenalty}%`
      : resolvedJudgmentFactor < -flagsInput?.judgmentLimits?.overallMaxDiscount
      ? `Exceeds overall max discount of -${flagsInput?.judgmentLimits?.overallMaxDiscount}%`
      : false;

  return {
    ...flagsInput,
    judgmentFactor: numbers.clamp(
      resolvedJudgmentFactor,
      -flagsInput?.judgmentLimits?.overallMaxDiscount,
      flagsInput?.judgmentLimits?.overallMaxPenalty
    ),
    judgmentFactorWarning,
    judgments: resolvedJudgments || [],
  };
};
